import { useBook2 } from '@orientaction/hooks_book';
import EbookReaderLayout from './components/EbookReaderLayout';
import Step2Content from './components/Step2Content';
import { useLegacyEbookReader } from './hooks/useLegacyEbookReader';

const EbookDevStep2 = () => {
  const { initValue, getMyValueBook, setId } = useBook2();
  const reader = useLegacyEbookReader({
    getMyValueBook,
    hydrateValue: initValue,
    setId,
  });

  return (
    <EbookReaderLayout {...reader} ebookName="l’Étape 2">
      {(readOnly) => <Step2Content readOnly={readOnly} />}
    </EbookReaderLayout>
  );
};

export default EbookDevStep2;
